import React from "react";
import { Aside } from "sprint-common-web";

import { EditEmbeddedSubtitleAsideContent } from "./EditEmbeddedSubtitleAsideContent";

export interface EditEmbeddedSubtitleAsideProps {
    fileRecordId: string;
    isOpen: boolean;
    onCancel(): void;
    onSubmit(): void;
}

export const EditEmbeddedSubtitleAside: React.FC<EditEmbeddedSubtitleAsideProps> = (
    props: EditEmbeddedSubtitleAsideProps
) => {
    const { fileRecordId, isOpen, onSubmit, onCancel } = props;

    return (
        <Aside
            type="form"
            headerText="Edit embedded subtitle"
            isOpen={isOpen}
            onDismiss={onCancel}
            isLightDismiss={true}
        >
            <EditEmbeddedSubtitleAsideContent fileRecordId={fileRecordId} onCancel={onCancel} onSubmit={onSubmit} />
        </Aside>
    );
};
